export interface ChartDataPoint {
  month: string;
  clients: number;
  date: string;
}

export const chartData: ChartDataPoint[] = [
  { month: 'Jan-24', clients: 120, date: '2024-01-01' },
  { month: 'Feb-24', clients: 180, date: '2024-02-01' },
  { month: 'Mar-24', clients: 250, date: '2024-03-01' },
  { month: 'Apr-24', clients: 320, date: '2024-04-01' },
  { month: 'May-24', clients: 450, date: '2024-05-01' },
  { month: 'Jun-24', clients: 600, date: '2024-06-01' },
  { month: 'Jul-24', clients: 750, date: '2024-07-01' },
  { month: 'Aug-24', clients: 900, date: '2024-08-01' },
  { month: 'Sep-24', clients: 1100, date: '2024-09-01' },
  { month: 'Oct-24', clients: 1300, date: '2024-10-01' },
  { month: 'Nov-24', clients: 50, date: '2024-11-01' },
  { month: 'Dec-24', clients: 150, date: '2024-12-01' },
  { month: 'Jan-25', clients: 300, date: '2025-01-01' },
  { month: 'Feb-25', clients: 600, date: '2025-02-01' },
  { month: 'Mar-25', clients: 900, date: '2025-03-01' },
  { month: 'Apr-25', clients: 1200, date: '2025-04-01' },
  { month: 'May-25', clients: 1800, date: '2025-05-01' },
  { month: 'Jun-25', clients: 1900, date: '2025-06-01' },
  { month: 'Jul-25', clients: 800, date: '2025-07-01' },
  { month: 'Aug-25', clients: 80, date: '2025-08-01' },
  { month: 'Sep-25', clients: 200, date: '2025-09-01' },
  { month: 'Oct-25', clients: 500, date: '2025-10-01' },
  { month: 'Nov-25', clients: 900, date: '2025-11-01' },
  { month: 'Dec-25', clients: 1200, date: '2025-12-01' },
];

export const filterDataByDateRange = (
  data: ChartDataPoint[],
  startDate: string | null,
  endDate: string | null
): ChartDataPoint[] => {
  if (!startDate && !endDate) return data;
  
  return data.filter(item => {
    const itemDate = new Date(item.date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
    
    if (start && end) {
      return itemDate >= start && itemDate <= end;
    } else if (start) {
      return itemDate >= start;
    } else if (end) {
      return itemDate <= end;
    }
    
    return true;
  });
}; 